import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { MatRadioButton } from "@angular/material/radio";
import { Observable } from "rxjs";
import { MyMbtiGuestQuizReport, MyMbtiHostQuizReport } from "src/app/interfaces/mbti";
import { MbtiService } from "src/app/services/mbti/mbti.service";
import { ModalService } from "src/app/services/modal/modal.service";
import { QuizService } from "src/app/services/quiz/quiz.service";
import { SnackbarService } from "src/app/services/snackbar/snackbar.service";
import { AlertDialogComponent } from "../../modals/alert-dialog/alert-dialog.component";
import { MenuDialogComponent } from "../../modals/menu-dialog/menu-dialog.component";

@Component({
  template: ''
})
export abstract class MyCard {

  @ViewChild('button') button: MatRadioButton | undefined;
  @Input() abstract quizReport: MyMbtiHostQuizReport | MyMbtiGuestQuizReport | undefined;
  @Input() hideButton = false;
  @Input() radioButton = false;
  @Output() selected = new EventEmitter<boolean>();
  radioButtonChecked = false;

  constructor(
    protected quizService: QuizService,
    protected snackbarService: SnackbarService,
    protected modalService: ModalService,
    protected mbtiService: MbtiService
  ) { }

  protected abstract getMenuDialogData(): void;
  protected abstract get removeDialogData(): any;

  clickRadioButton($event: Event): void {
    if (this.button !== undefined) {
      $event.stopPropagation();
      this.button.checked = true;
      this.onSelected();      
    }
  }

  onSelected($event?: Event): void {
    if ($event !== undefined) {
      $event.stopPropagation();
    }
    this.selected.emit(true);
  }

  async onClickOption($event: Event): Promise<void> {
    $event.stopPropagation();
    const menuDialog = await this.modalService.openMenuDialog(MenuDialogComponent, { data: this.getMenuDialogData() });
    await menuDialog.present();
  }

  protected async showRemoveDialog(): Promise<void> {
    const dialog = await this.modalService.openDialog(AlertDialogComponent, {
      data: this.removeDialogData
    });
    await dialog.present();
  }
  
  protected onErrorDeleteQuizReport(): void {
    this.snackbarService.openSnackBar(SnackbarService.DELETE_FAILED);
  }
  
  protected removeCurrentQuizReport(): void {
    if (this.quizReport !== undefined) {
      this.quizReport.isRemoved = true;
      this.quizService.quizReportDeleted(this.quizReport.id);
    }
  }

  protected removeQuizReport(): Observable<void> {
    return new Observable<void>((observer) => {
      if (this.quizReport !== undefined) {
        this.mbtiService.removeMbtiQuizReport(this.quizReport.id).subscribe((res) => {
          this.removeCurrentQuizReport();
          observer.next();
        }, error => {
          this.onErrorDeleteQuizReport();
          observer.next();
        });
      } else {
        observer.next();
      }
    })
  }
}
